import { graphql, useStaticQuery } from 'gatsby'
export default function useCities() {
	const result = useStaticQuery(
		graphql`
			query cities {
				allContentfulTenaPaises {
					nodes {
						node_locale
						codigoDeDosLetras
						lenguaje
						titulo
						dominio
						nombreDepartamento
						nombreCiudad
						departamentos {
							nombre
							codigo
							id
						}
						ciudades {
							codigo
							codigoDepartamento
							id
							nombre
						}
						prefijoTelefonico
					}
				}
			}
		`
	)
	const citiesInfo = result.allContentfulTenaPaises.nodes
		.filter(e => e.node_locale === 'es-CO')
		.filter(c => c.codigoDeDosLetras === process.env.LOCALE.split('-')[1])[0]
	// const citiesInfo = result.allContentfulTenaPaises.nodes.filter(e => e.node_locale === 'es-CO').filter(c => c.codigoDeDosLetras === 'PR')[0];
	return citiesInfo
}
